// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".systemServiceList[data-v-36b406f5]{padding:20px;padding-left:70px}.addService[data-v-36b406f5]{margin-bottom:20px}", ""]);
// Exports
module.exports = exports;
